import { useEffect, useState } from 'react';
export var useGetBlockNumWithLessons = function (blocks) {
    var _a = useState(0), visibleBlocks = _a[0], setVisibleBlocks = _a[1];
    useEffect(function () {
        var calculateVisibleBlocks = function () {
            var _a, _b, _c, _d;
            var lessonBlocks = (_a = (blocks || [])) === null || _a === void 0 ? void 0 : _a.filter(function (block) { return (block === null || block === void 0 ? void 0 : block.style) === "course_lesson"; });
            var hiddenBlocksLength = ((_d = (_c = (_b = (lessonBlocks || [])) === null || _b === void 0 ? void 0 : _b.map(function (block) {
                return Boolean(document.querySelector("[data-rbd-draggable-id=\"".concat((block === null || block === void 0 ? void 0 : block.postId) || '', "\"] div")));
            })) === null || _c === void 0 ? void 0 : _c.filter(function (block) { return !block; })) === null || _d === void 0 ? void 0 : _d.length) || 0;
            setVisibleBlocks((blocks === null || blocks === void 0 ? void 0 : blocks.length) - hiddenBlocksLength);
        };
        calculateVisibleBlocks();
        var observer = new MutationObserver(function () {
            calculateVisibleBlocks();
        });
        var config = { childList: true, subtree: true };
        var targetNode = document.body;
        observer.observe(targetNode, config);
        return function () {
            observer.disconnect();
        };
    }, [blocks]);
    return visibleBlocks;
};
//# sourceMappingURL=useGetBlockNumWithLessons.js.mapimport { useEffect, useState } from 'react';
export var useGetBlockNumWithLessons = function (blocks) {
    var _a = useState(0), visibleBlocks = _a[0], setVisibleBlocks = _a[1];
    useEffect(function () {
        var calculateVisibleBlocks = function () {
            var _a, _b, _c, _d;
            var lessonBlocks = (_a = (blocks || [])) === null || _a === void 0 ? void 0 : _a.filter(function (block) { return (block === null || block === void 0 ? void 0 : block.style) === "course_lesson"; });
            var hiddenBlocksLength = ((_d = (_c = (_b = (lessonBlocks || [])) === null || _b === void 0 ? void 0 : _b.map(function (block) {
                return Boolean(document.querySelector("[data-rbd-draggable-id=\"".concat((block === null || block === void 0 ? void 0 : block.postId) || '', "\"] div")));
            })) === null || _c === void 0 ? void 0 : _c.filter(function (block) { return !block; })) === null || _d === void 0 ? void 0 : _d.length) || 0;
            setVisibleBlocks((blocks === null || blocks === void 0 ? void 0 : blocks.length) - hiddenBlocksLength);
        };
        calculateVisibleBlocks();
        var observer = new MutationObserver(function () {
            calculateVisibleBlocks();
        });
        var config = { childList: true, subtree: true };
        var targetNode = document.body;
        observer.observe(targetNode, config);
        return function () {
            observer.disconnect();
        };
    }, [blocks]);
    return visibleBlocks;
};
//# sourceMappingURL=useGetBlockNumWithLessons.js.map